import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20elegant%20flat%20lay%20of%20premium%20fashion%20pieces%20including%20a%20cream%20cashmere%20sweater%20folded%20designer%20sneakers%20and%20gold%20toned%20accessories%20arranged%20on%20warm%20textured%20linen%20surface%20soft%20diffused%20natural%20window%20light%20refined%20editorial%20composition%20European%20luxury%20aesthetic%20warm%20beige%20sand%20and%20cream%20tones%20sophisticated%20minimal%20styling%20high%20resolution&width=1800&height=1200&seq=hero-bg-fashion-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti moda"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <div className="flex items-center justify-center gap-3 mb-8 flex-wrap">
          <span className="px-3 py-1 text-xs font-medium bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full border border-background-50/20 whitespace-nowrap">
            ✓ {t("hero.badge_1")}
          </span>
          <span className="px-3 py-1 text-xs font-medium bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full border border-background-50/20 whitespace-nowrap">
            ✓ {t("hero.badge_2")}
          </span>
          <span className="px-3 py-1 text-xs font-medium bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full border border-background-50/20 whitespace-nowrap">
            ✓ {t("hero.badge_3")}
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 font-semibold leading-tight mb-6">
          {t("hero.title")}
        </h1>
        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto leading-relaxed mb-10">
          {t("hero.subtitle")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-base rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            {t("hero.cta_primary")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-base rounded-full border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            {t("hero.cta_secondary")}
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>

        <Link
          to="/articolo/guida-completa-itaobuy-spreadsheet"
          className="inline-flex items-center gap-2 mt-8 text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
        >
          <i className="ri-article-line"></i>
          {t("article.readMore")}
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#categories"
          className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
        >
          <span className="text-xs font-medium uppercase tracking-widest whitespace-nowrap">Scopri</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}